import { Form, FormItem, Input } from 'formik-antd';
import { Button } from 'antd';
import * as React from 'react';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export interface MfaCodeFormProps {
  loading: boolean;
}

type LoginFormOwnProps = MfaCodeFormProps;

export const MfaCodeForm: React.FC<LoginFormOwnProps> = (props) => {
  const intlMessage = useFormatMessage();

  return (
    <Form>
      <FormItem name="mfaVerificationCode">
        <Input
          name="mfaVerificationCode"
          placeholder={intlMessage({ id: 'pinCode' })}
        />
      </FormItem>
      <Button
        id="button-verify-mfa-code"
        htmlType="submit"
        loading={props.loading}
        style={{ width: '100%' }}
        type="primary"
      >
        {props.loading && intlMessage({ id: 'loading' })}
        {!props.loading && intlMessage({ id: 'pinCode.verify' })}
      </Button>
    </Form>
  );
};
